import { createAction, props } from '@ngrx/store';
import { FilterGroupModel } from '@tailormap-viewer/api';
import { AttributeFilterModel } from '@tailormap-viewer/api';

const filterActionsPrefix = '[Filter]';

export const addAllFilterGroupsInConfig = createAction(
  `${filterActionsPrefix} Add All Filter Groups In Config`,
  props<{ filterGroups: FilterGroupModel<AttributeFilterModel>[] }>(),
);

export const addFilterGroup = createAction(
  `${filterActionsPrefix} Add Filter Group`,
  props<{ filterGroup: FilterGroupModel }>(),
);

export const removeFilterGroup = createAction(
  `${filterActionsPrefix} Remove Filter Group`,
  props<{ filterGroupId: string }>(),
);

export const updateFilterGroup = createAction(
  `${filterActionsPrefix} Update Filter Group`,
  props<{ filterGroup: FilterGroupModel }>(),
);

export const addOrUpdateFilterGroups = createAction(
  `${filterActionsPrefix} Add or Update Filter Groups`,
  props<{ filterGroups: FilterGroupModel[] }>(),
);

export const addFilter = createAction(
  `${filterActionsPrefix} Add Attribute Filter`,
  props<{ filterGroupId: string; filter: AttributeFilterModel }>(),
);

export const removeFilter = createAction(
  `${filterActionsPrefix} Remove Attribute Filter`,
  props<{ filterGroupId: string; filterId: string }>(),
);

export const updateFilter = createAction(
  `${filterActionsPrefix} Update Attribute Filter`,
  props<{ filterGroupId: string; filter: AttributeFilterModel }>(),
);

export const toggleFilterDisabled = createAction(
  `${filterActionsPrefix} Toggle Filter Disabled`,
  props<{ filterGroupId: string }>(),
);

export const setSingleFilterDisabled = createAction(
  `${filterActionsPrefix} Toggle Single Filter Disabled`,
  props<{ filterGroupId: string; filterId: string; disabled: boolean }>(),
);

export const addLayerIdsToFilterGroup = createAction(
  `${filterActionsPrefix} Add Layer Ids To Filter Group`,
  props<{ filterGroupId: string; layerIds: string[] }>(),
);

export const resetAttributeFilters = createAction(
  `${filterActionsPrefix} Reset Attribute Filters`,
);
